import * as React from "react";

const HomeScreen = () => {
  return <h1>Lorem Ipsum!</h1>;
};

export default HomeScreen;
